// extracted by mini-css-extract-plugin
export default {"wrapper":"AnalysisConfigSetting_wrapper__msnas"};